module.exports = __webpack_public_path__ + "img/public/SiteIcons/popularPrevArrow.svg?b050ccf0";